module.exports = require('react-text-mask');
